import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled, alpha } from '@zenbusiness/zui/styles';

export const ListCard = superstyled({
  tag: List,
  name: 'ProductCards',
  slot: 'ListCard',
  styles: ({ theme, columns }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: 16,

    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },

    [theme.breakpoints.up('lg')]: {
      gap: 24,
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
    },
  }),
});

export const ProductCard = superstyled({
  tag: Card,
  name: 'ProductCards',
  slot: 'ProductCard',
  styles: ({ theme }) => ({
    padding: '1.5rem',
    height: '100%',
    boxShadow: theme.shadows[1],
  }),
});

export const ProductListItem = superstyled({
  tag: ListItem,
  name: 'ProductCards',
  slot: 'ProductListItem',
  styles: ({ theme }) => ({
    padding: theme.spacing(0),
  }),
});

export const CardImageContainer = superstyled({
  tag: Stack,
  name: 'ProductCards',
  slot: 'CardImageContainer',
  styles: ({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.shape.rounded.full,
    backgroundColor: alpha(theme.palette.background.blue.light, 0.2),

    width: '4.375rem',
    height: '4.375rem',

    [theme.breakpoints.up('lg')]: {
      width: '4.875rem',
      height: '4.875rem',
    },
  }),
});

export const CardImage = superstyled({
  tag: SharedAsset,
  name: 'ProductCards',
  slot: 'CardImage',
  styles: ({ theme }) => ({
    width: '3.125rem',
    height: '3.125rem',
    objectFit: 'contain',

    [theme.breakpoints.up('lg')]: {
      width: '3.5rem',
      height: '3.5rem',
    },
  }),
});

export const SpinnerContainer = superstyled({
  tag: Box,
  name: 'ProductCards',
  slot: 'SpinnerContainer',
  styles: ({ theme }) => ({
    inset: 0,
    width: '100%',
    minHeight: '100vh',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',

    '& .ZuiLoadingSpinner-root': {
      marginTop: theme.spacing(12),
    },
  }),
});

export const ExternalIconContainer = superstyled({
  tag: Box,
  name: 'ProductCards',
  slot: 'ExternalIconContainer',
  styles: ({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
  }),
});
